// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2XhLA","right":"styles_right__F-S1n"};